import moment from "moment";
import { validUser } from "./users";

export function humanDuration(minutes) {
  const d = moment.duration(minutes, "minutes");

  if (minutes < 0.001) {
    return "0";
  }

  if (d <= moment.duration(1, "minutes")) {
    return `${d.seconds()}s`;
  }

  if (d <= moment.duration(90, "minutes")) {
    return `${d.asMinutes().toFixed(1)}m`;
  }

  if (d <= moment.duration(48, "hours")) {
    return `${d.asHours().toFixed(1)}h`;
  }

  if (d <= moment.duration(2, "week")) {
    return `${d.asDays().toFixed(1)}d`;
  }

  return `${d.asWeeks().toFixed(1)}w`;
}

export function humanRoughNumber(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" }
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;

  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
      );
    }
  }
  return num.toFixed(digits).replace(rx, "$1");
}

export const sumAvgMaxStats = arr => {
  const n = arr.length;
  if (n === 0) {
    return { n, sum: 0, avg: 0, max: 0 };
  }
  const sum = arr.reduce((a, b) => a + b);
  const avg = sum / n;
  const max = Math.max(...arr);
  return { n, sum, avg, max };
};

export function numberWithCommas(x) {
  const parts = x.toString().split(".");
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    (parts[1] ? "." + parts[1] : "")
  );
}

export function fixed2(x) {
  return x.toFixed(2);
}

export function dollarValue(x) {
  return `$${x.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")}`;
}

export function percentageValue(x) {
  return `${Math.round(x * 100).toString()}%`;
}

export function capitalize(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function extractNames(str) {
  return str.split("@")[0].split(/[._-\s+]+/);
}

export function displayName(user) {
  if (!validUser(user)) return "";

  let parts = [];
  if (user.firstname) {
    parts[0] = user.firstname;
    if (user.lastname) {
      parts[1] = user.lastname;
    }
  } else {
    parts = extractNames(user.email).slice(0, 3);
  }
  return parts.map(capitalize).join(" ");
}

function firstUpper(word) {
  return word.charAt(0).toUpperCase();
}

function extractInitials(words) {
  return words
    .split("@")[0]
    .split(/[._-\s]+/)
    .map(word => {
      return firstUpper(word);
    })
    .slice(0, 3)
    .join("");
}

export function avatarInitials(obj) {
  if (obj) {
    if (obj.firstname) {
      let initials = "";
      initials = firstUpper(obj.firstname);
      if (obj.lastname) {
        initials += firstUpper(obj.lastname);
      }
      return initials;
    }

    if (obj.name) {
      return extractInitials(obj.name);
    }

    if (obj.email) {
      return extractInitials(obj.email);
    }
  }
  return "??";
}

export function sortByKey(arr, key, ascending = true, caseSensitive = false) {
  const before = ascending ? -1 : 1;
  const after = ascending ? 1 : -1;

  return arr.sort(function(a, b) {
    let afield = a[key];
    let bfield = b[key];
    if (
      !caseSensitive &&
      typeof afield === "string" &&
      typeof bfield === "string"
    ) {
      afield = afield.toLowerCase();
      bfield = bfield.toLowerCase();
    }
    if (afield < bfield) return before;
    if (afield > bfield) return after;
    return 0;
  });
}

export function dateHeadings() {
  return [
    { flat: "day", nice: "Today" },
    { flat: "week", nice: "This week" },
    { flat: "month", nice: "This month" },
    { flat: "year", nice: "This year" },
    { flat: "all", nice: "All time" }
  ];
}

export function getDateHeading(date) {
  const headings = dateHeadings();
  for (let i = 0; i < headings.length; i++) {
    if (moment().isSame(moment(date), headings[i].flat)) {
      return headings[i].nice;
    }
  }
  return headings[headings.length - 1].nice;
}

export function roleNames() {
  return [
    { flat: "superuser", nice: "Superuser" },
    { flat: "owner", nice: "Owner" },
    { flat: "admin", nice: "Administrator" },
    { flat: "user", nice: "User" }
  ];
}

export function roleName(role, nice = true) {
  if (!(role > -1 && role < 4)) return "";
  const names = roleNames();
  return nice ? names[role].nice : names[role].flat;
}



// WEBPACK FOOTER //
// ./src/helpers/presentation.js